<template>
  <div class="i-login">
    <van-image
      class="i-login-logo"
      width="180px"
      height="105px"
      fit="contain"
      :src="require('@/assets/images/logo/logo1.png')"
    />
    <van-form @submit="onSubmit" class="i-login-form">
      <van-field
        v-model="state.username"
        name="username"
        label="账号"
        placeholder="请填写账号"
        :rules="[{ required: true, message: '请填写账号' }]"
      />
      <van-field
        v-model="state.password"
        type="password"
        name="password"
        label="密码"
        placeholder="请填写密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div style="margin: 50px 16px 0">
        <van-button
          round
          block
          type="primary"
          color="linear-gradient(to right, #0059ff, #86eafa)"
          native-type="submit"
        >
          登录
        </van-button>
      </div>
    </van-form>
    <div class="i-login-tip">
      温馨提示：账号为用户姓名或手机号码！如需添加用户，请联系单位工程部！
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import { useStore } from "@/store";
import { useRouter, useRoute } from "vue-router";
import { loginService } from "@/service";
import { Toast } from "vant";
export default {
  name: "Login",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      username: "",
      password: "",
    });

    const preCheck = async () => {
      if (route.query.qiye_uid) {
        const data = await loginService.login2({
          qiye_uid: route.query.qiye_uid,
          qiye_uid_key: route.query.qiye_uid_key,
        });
        store.commit("setUserInfo", data.data[0]);
        router.replace({
          name: "Index",
          query: route.query,
        });
      }
    };
    preCheck();

    const onSubmit = async (values) => {
      try {
        let data = null;
        if (route.query.qiye_uid) {
          data = await loginService.login2({
            ...values,
            qiye_uid: route.query.qiye_uid,
            qiye_uid_key: route.query.qiye_uid_key,
          });
        } else {
          data = await loginService.login(values);
        }
        store.commit("setUserInfo", data.data[0]);
        router.replace({
          name: "Index",
        });
      } catch (error) {
        Toast.fail("用户或密码错误");
      }
    };
    return {
      state,
      onSubmit,
    };
  },
};
</script>
<style lang="less" scoped>
.i-login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #fff;
  &-logo {
    margin-top: 30px;
  }
  &-form {
    margin-top: 50px;
    width: 100%;
  }
  &-tip {
    font-size: 14px;
    color: #999;
    margin-top: auto;
  }
}
</style>
